<template>
<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.98784 12.3987C11.8173 12.3987 13.2758 10.9486 13.2758 9.18423C13.2758 7.41988 11.7925 5.96973 9.98784 5.96973C8.18314 5.96973 6.69983 7.41988 6.69983 9.18423C6.69983 10.9486 8.15842 12.3987 9.98784 12.3987Z" fill="white" fill-opacity="0.4"/>
<path d="M0 3.72236V14.3326C0 15.2511 0.766378 16.0003 1.70581 16.0003H18.2942C19.2336 16.0003 20 15.2511 20 14.3326V3.72236C20 2.80393 19.2336 2.05469 18.2942 2.05469H1.70581C0.741656 2.05469 0 2.80393 0 3.72236ZM16.267 4.66496C16.7862 4.66496 17.1817 5.07584 17.1817 5.55922C17.1817 6.06677 16.7614 6.45348 16.267 6.45348C15.7726 6.45348 15.3523 6.0426 15.3523 5.55922C15.3276 5.05167 15.7478 4.66496 16.267 4.66496ZM9.98764 4.76164C12.4845 4.76164 14.5117 6.74351 14.5117 9.1846C14.5117 11.6257 12.4845 13.6076 9.98764 13.6076C7.49073 13.6076 5.46354 11.6257 5.46354 9.1846C5.46354 6.74351 7.49073 4.76164 9.98764 4.76164Z" fill="white" fill-opacity="0.4"/>
<path d="M6.37851 1.20846C6.72462 1.20846 6.99656 0.942598 6.99656 0.60423C6.99656 0.265861 6.6999 0 6.37851 0H3.83216C3.48605 0 3.21411 0.265861 3.21411 0.60423C3.21411 0.942598 3.48605 1.20846 3.83216 1.20846H6.37851Z" fill="white" fill-opacity="0.4"/>
</svg>

</template>

<script>
export default {

}
</script>

<style>

</style>